import { ChakraText as Text } from "@airhelp/react-ui-components";
import type { FormSuccessMessageProps } from "./FormSuccessMessage.d";

const FormSuccessMessage = ({ text }: FormSuccessMessageProps) => (
  <Text fontSize="lg" color="success.500" mt={4}>
    {text}
  </Text>
);

export default FormSuccessMessage;
